import { WidgetInstance } from 'friendly-challenge'
import { useCaptchaStoreActions } from 'modules/auth/store/useCaptchaStore'
import { FriendlyCaptchaWidgetProps } from 'modules/auth/types/captcha'
import { useUserLocale } from 'modules/common/hooks/useUserLocale'
import React, { useEffect, useRef, useState } from 'react'

const CAPTCHA_ENDPOINT = 'https://eu-api.friendlycaptcha.eu/api/v1/puzzle'
const CAPTCHA_SITEKEY = process.env.NEXT_PUBLIC_FRIENDLY_CAPTCHA_SITEKEY!

export const CaptchaWidget = React.memo((props: FriendlyCaptchaWidgetProps) => {
  const { clearWidgetInstance, setWidgetInstance } = useCaptchaStoreActions()
  const captchaWidget = useRef<WidgetInstance | null>(null)
  const userLocale = useUserLocale()
  const container = useRef<HTMLDivElement | null>(null)
  const [captchaRendered, setCaptchaRendered] = useState<boolean>(false)

  useEffect(() => {
    if (!captchaRendered && container.current) {
      captchaWidget.current = new WidgetInstance(container.current, {
        puzzleEndpoint: CAPTCHA_ENDPOINT,
        startMode: 'auto',
        doneCallback: props.solvedHandler,
        errorCallback: props.errorHandler,
        sitekey: CAPTCHA_SITEKEY,
        language: userLocale,
      })

      setWidgetInstance(captchaWidget.current)

      setCaptchaRendered(true)
    }

    return () => {
      if (captchaWidget.current !== null && captchaRendered) {
        clearWidgetInstance()
        captchaWidget.current.destroy()
        setCaptchaRendered(false)
        props.resetHandler()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div
      ref={container}
      className={props.className}
      data-sitekey={CAPTCHA_SITEKEY}
    />
  )
})
